<template>
    <div>
        <div>
            <!-- SELECT STATUS -->
            <el-form-item
                :label="$t.__('dashboard.forms.OpportunitySettingForm.select_status_to_display')"
                prop="status"
            >
                <el-select v-model="form.status" multiple :multiple-limit="2" class="wp-4">
                    <el-option
                        v-for="status in statusList"
                        :key="status.value"
                        :label="status.label"
                        :value="status.value"
                    >
                    </el-option>
                </el-select>
            </el-form-item>

            <!-- SELECT PIPE -->
            <el-form-item
                :label="$t.__('dashboard.forms.OpportunitySettingForm.select_pipelines_to_use')"
                prop="pipeline"
            >
                <el-select
                    v-model="form.pipeline"
                    :placeholder="$t.__('dashboard.forms.OpportunitySettingForm.all_pipelines')"
                    multiple
                    class="wp-4"
                >
                    <el-option
                        v-for="pipeline in pipelineList"
                        :key="pipeline.value"
                        :label="pipeline.label"
                        :value="pipeline.value"
                    >
                    </el-option>
                </el-select>
            </el-form-item>

            <!-- SUBMIT -->
            <div class="aright mt-5">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="close"
                />
                <CompassButton
                    :label="$t.__('common.actions.save')"
                    type="primary"
                    @click="submitForm"
                />
            </div>
        </div>
    </div>
</template>

<script>
import SettingsFormMixin from './SettingsFormMixin.js';

export default {
    mixins: [SettingsFormMixin],
    created() {
        this.$emit('updateLoading', { loading: true });
        this.$ajax.get('/rest/prospection/funnel/getAll', {}, (data) => {
            data.forEach((funnel) => {
                this.pipelineList.push({
                    label: funnel.name,
                    value: funnel.id,
                });
            });
            this.$emit('updateLoading', { loading: false });
        });
    },
    data() {
        var checkStatus = (rule, value, callback) => {
            if (value.length == 2) {
                callback();
            } else {
                callback(new Error(this.$l10n.__('Veuillez sélectionner 2 statuts')));
            }
        };
        return {
            statusList: [
                {
                    label: this.$l10n.__('À échéance cette semaine'),
                    value: 'week',
                },
                {
                    label: this.$l10n.__('À échéance ce mois'),
                    value: 'month',
                },
                {
                    label: this.$l10n.__('Ouverte'),
                    value: 'open',
                },
                {
                    label: this.$l10n.__('En retard'),
                    value: 'late',
                },
            ],
            pipelineList: [],
            opportunityRules: {
                status: [
                    {
                        required: true,
                        message: this.$l10n.__('Veuillez sélectionner les statuts'),
                        trigger: 'blur',
                    },
                    { validator: checkStatus, trigger: 'change' },
                ],
            },
        };
    },
    methods: {
        close() {
            this.$emit('close-form');
        },
    },
    mounted() {
        this.$emit('set-rules', this.opportunityRules);
    },
};
</script>
